import { render, staticRenderFns } from "./TableStriped.vue?vue&type=template&id=6dd0435d"
import script from "./TableStriped.vue?vue&type=script&lang=js"
export * from "./TableStriped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports